<nz-card>
  <div class="dashboard-details-wrapper">
    <h3 nz-typography class="nfl-form-label">Build Your Dashboard</h3>
    <form nz-form [nzLayout]="'vertical'" [formGroup]="dashboardDetails!" class="form-grid">
      <div nz-row [nzGutter]="[16, 24]">
        <div nz-col class="gutter-row" [nzSpan]="24">
          <nz-form-item>
            <nz-form-label class="nfl-form-label" [nzNoColon]="true" [nzRequired]="true"> Name</nz-form-label>
            <nz-form-control [nzErrorTip]="nameErrorTemplate">
              <input nz-input formControlName="name" id="name" appTrimFormInput placeholder="Dashboard Name" />
            </nz-form-control>
            <ng-template #nameErrorTemplate let-control>
              <div *ngIf="control?.errors?.['required']">Name is required</div>
              <div *ngIf="control?.errors?.['maxlength']">
                Name cannot exceed
                {{ control?.errors?.['maxlength'].requiredLength }} characters.
              </div>
            </ng-template>
          </nz-form-item>
          <nz-form-item>
            <nz-form-label class="nfl-form-label" [nzNoColon]="true" [nzRequired]="true"> Description</nz-form-label>
            <nz-form-control [nzErrorTip]="descriptionErrorTemplate">
              <textarea
                nz-input
                id="description"
                placeholder="Dashboard Description"
                formControlName="description"
                [nzAutosize]="{ minRows: 2, maxRows: 5 }"
                appTrimFormInput
              ></textarea>
            </nz-form-control>
            <ng-template #descriptionErrorTemplate let-control>
              <div *ngIf="control?.errors?.['required']">Description is required</div>
              <div *ngIf="control?.errors?.['maxlength']">
                Description cannot exceed
                {{ control?.errors?.['maxlength'].requiredLength }} characters.
              </div>
            </ng-template>
          </nz-form-item>
        </div>
      </div>

      <h5 nz-typography class="nfl-form-label">Select Charts to Include</h5>
      <div class="search-sort-wrapper">
        <div class="search-wrapper">
          <nz-form-label class="nfl-form-label" nzNoColon>Search</nz-form-label>

          <span>
            <nz-input-group [nzSuffix]="inputClearTpl">
              <input
                nz-input
                nzSize="default"
                placeholder="Search by chart name, chart title, chart type or owner."
                formControlName="searchValue"
                type="text"
                (keyup)="search()"
              />
            </nz-input-group>
            <ng-template #inputClearTpl>
              <span
                *ngIf="searchValueFormControl?.value"
                nz-icon
                class="ant-input-clear-icon"
                nzTheme="fill"
                nzType="close-circle"
                (click)="reset()"
              ></span>
            </ng-template>
          </span>
        </div>
      </div>

      <div class="carousel-wrapper">
        <!-- Left Navigation -->
        <button
          nz-button
          nzShape="circle"
          nzType="default"
          class="nav-btn left"
          (click)="scrollPrev()"
          [disabled]="chartsToDisplay.length === 0"
        >
          <span nz-icon nzType="left" nzTheme="outline"></span>
        </button>

        <!-- Thumbnails -->
        <div class="carousel-track" #track>
          <ng-container *ngIf="chartsToDisplay.length > 0; else noChartsTemplate">
            <div
              class="carousel-item"
              *ngFor="let chart of chartsToDisplay"
              [ngStyle]="{
                backgroundImage: 'url(' + chart.chartDisplayImage + ')',
              }"
              [ngClass]="{ selected: isChartSelected(chart.chartId), 'background-opacity': isLoading }"
              (click)="selectChart(chart)"
              nz-tooltip
              nzTooltipTitle="Select or Deselect an item to add or remove widget in Dashboard Preview"
            >
              <nz-spin [nzSpinning]="isLoading" class="item-spinner"></nz-spin>
            </div>
          </ng-container>
        </div>

        <!-- Right Navigation -->
        <button
          nz-button
          nzShape="circle"
          nzType="default"
          class="nav-btn right"
          (click)="scrollNext()"
          [disabled]="chartsToDisplay.length === 0"
        >
          <span nz-icon nzType="right" nzTheme="outline"></span>
        </button>
      </div>

      <nz-divider></nz-divider>

      <app-dashboard-preview
        [dashboardDetails]="dashboardDetails"
        [activeDashboardData]="activeDashboardData"
        [isEditMode]="isEditMode"
      ></app-dashboard-preview>
    </form>
  </div>
</nz-card>

<ng-template #noChartsTemplate>
  <div class="no-charts-container">
    <nz-empty nzNotFoundImage="simple" nzNotFoundContent="No charts available"></nz-empty>
  </div>
</ng-template>
